import templateStr from 'text!./advanced-filter-option.html';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            customFilter: '=',
            advancedFilter: '=',
            filteredItemsCount: '@',
            optionChangeFunction: '&',
            showSubOptionsFunction: '&'
        },
        controller: ['$scope', ($scope) => {
            $scope.checkShowSubOptions = () => {
                return $scope.showSubOptionsFunction();
            };

            $scope.setAllOptions = (subFilter, value) => {
                subFilter.options.forEach((option) => {
                    option.selected = value;
                });
                $scope.optionChangeFunction();
            };
        }]
    };
}];